import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LionsStripe from '../components/LionsStripe';
import { HomeIcon } from '@heroicons/react/24/outline';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-accent-light font-sans selection:bg-secondary selection:text-white">
      <Navbar />

      <main id="main-content">
        <section className="relative pt-40 pb-24 min-h-[70vh] flex items-center justify-center overflow-hidden bg-primary">
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-br from-primary via-navy-900 to-primary"></div>
          </div>

          <div className="max-w-2xl mx-auto px-4 text-center relative z-10 bg-primary rounded-2xl py-1">
            <p className="text-secondary font-bold tracking-widest text-sm uppercase mb-4">
              Error 404
            </p>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight">
              Page Not Found
            </h1>
            <p className="text-lg text-white/80 font-light max-w-xl mx-auto mb-10">
              The page you're looking for doesn't exist or may have moved. Let's get you back on track.
            </p>
            <a
              href="/"
              className="inline-flex items-center gap-2 bg-orange-700 hover:bg-orange-800 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300"
            >
              <HomeIcon className="w-5 h-5" aria-hidden="true" />
              Back to Home
            </a>
          </div>
          <LionsStripe className="absolute inset-x-0 bottom-0 z-10" />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default NotFoundPage;
